<!--
  @component
  Generates a canvas map using the `geoPath` function from [d3-geo](https://github.com/d3/d3-geo).
 -->
<script>
	import { getContext } from "svelte";
	import { scaleCanvas } from "layercake";
	import { geoPath } from "d3-geo";

	const { data, width, height, zGet } = getContext("LayerCake");

	const { ctx } = getContext("canvas");

	export let projection;

	/** @type {String} [fill='#ccc'] - The shape's fill color. */
	export let fill = "#000";

	

	/** @type {String} [stroke='#ccc'] - The shape's stroke color. */
	export let stroke = "#fff";

	/** @type {Number} [strokeWidth=1] - The shape's stroke width. */
	export let strokeWidth = 1;

	export let background = "#000";

	export let statesFeatures = [];
	export let worldFeatures = [];
	export let hideWorldFeatures = true;

	$: geoPathFn = geoPath(projection);

	$: {
		if ($ctx && geoPath) {
			scaleCanvas($ctx, $width, $height);
			$ctx.clearRect(0, 0, $width, $height);

			worldFeatures.forEach((feature) => {
				$ctx.beginPath();
				// Set the context here since setting it in `$: geoPath` is a circular reference
				geoPathFn.context($ctx);
				geoPathFn(feature);

				$ctx.globalAlpha = hideWorldFeatures ? 0 : 1;
				$ctx.fillStyle = feature.properties.name_en === "Europe" ? "transparent" : fill;
				$ctx.fill();

				$ctx.lineWidth = strokeWidth;
				$ctx.strokeStyle = feature.properties.name_en === "Europe" ? background : stroke;
				$ctx.stroke();
			});

			statesFeatures.forEach((feature) => {
				$ctx.beginPath();
				// Set the context here since setting it in `$: geoPath` is a circular reference
				geoPathFn.context($ctx);
				geoPathFn(feature);

				$ctx.fillStyle = feature.properties.name === "US" ? "transparent" : fill;
				$ctx.globalAlpha = 1;
				$ctx.fill();

				$ctx.lineWidth = strokeWidth;
				$ctx.strokeStyle = feature.properties.name === "US" ? background : stroke;
				$ctx.stroke();
			});
		}
	}
</script>
